let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("5r2E7")), load("4tWJj")]).then(() => parcelRequire('j5C3s'));